import http from 'hub-http/clients/apiClient';
import { OBJECT_TYPE } from '../constants/objectTypes';
const MARKETING_ASSET_PERMISSION_TEAMS = 'marketing/asset-permissions/v1/teams';
const MARKETING_ASSET_PERMISSION_USERS = 'marketing/asset-permissions/v1/users';

// TODO: Add correct manage access api calls for other object types

export function getTeamPermissions({
  objectType,
  objectId
}) {
  switch (objectType) {
    case OBJECT_TYPE.CAMPAIGN:
      return http.get(`${MARKETING_ASSET_PERMISSION_TEAMS}/${objectType}/${objectId}`);
    default:
      return Promise.resolve([]);
  }
}
export function getUserPermissions({
  objectType,
  objectId
}) {
  switch (objectType) {
    case OBJECT_TYPE.CAMPAIGN:
      return http.get(`${MARKETING_ASSET_PERMISSION_USERS}/${objectType}/${objectId}`);
    default:
      return Promise.resolve([]);
  }
}
export function saveTeamPermissions({
  objectType,
  objectId,
  teamIds
}) {
  switch (objectType) {
    case OBJECT_TYPE.CAMPAIGN:
      return http.put(`${MARKETING_ASSET_PERMISSION_TEAMS}/${objectType}`, {
        data: {
          assetIds: [objectId],
          teamIds
        }
      }).then(() => teamIds);
    default:
      return Promise.resolve([]);
  }
}
export function saveUserPermissions({
  objectType,
  objectId,
  userIds
}) {
  switch (objectType) {
    case OBJECT_TYPE.CAMPAIGN:
      return http.put(`${MARKETING_ASSET_PERMISSION_USERS}/${objectType}/${objectId}`, {
        data: userIds
      }).then(() => userIds);
    default:
      return Promise.resolve([]);
  }
}